import React from 'react';
import { BarChart } from '../../chart';
import { getOriginTitle } from '../../../config';
import './details-chart.scss';

const Origin = ({ data }) => {

    if (!data) return null;

    return (
        <div className="details-scb-chart details-scb-chart--origin">
            <h2 className="details-scb-chart__heading">Ursprung</h2>
            <p className="details-scb-chart__value">Antal personer: {data.total.toLocaleString('sv')} st</p>
            <BarChart 
                valueLabel="Antal personer:"
                unit="st"
                total={data.total}
                totalLabel="Andel:"
                data={data.dataItems.map(item => {
                    return {
                        name: getOriginTitle(item.title),
                        data: item.value
                    }
                })} dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]} />
        </div>
    );
};

export default Origin;